<img loading="lazy" src="assets/img/student.webp" class="swiper-static-image" />
    
<swiper
[slidesPerView]="1"
[spaceBetween]="0"
[pagination]="{ clickable: true }"
(swiper)="onSkillsSwiper($event)"
(slideChange)="onSlideChange()"
class="w-100"
>
    <ng-template swiperSlide class="w-100">
        <div class="w-100 action-container">
            <div class="div-left d-inline-flex align-items-center">
                <div class="content">
                    <h2 class="font-weight-bold text-white">CIMA Classes start 5 July.</h2>
                    <p>Join our local and global lecturers.</p>
                </div>
            </div>
            <div class="div-right d-inline-flex align-items-center justify-content-end">
                <a routerLink="/course-catalogue"><button type="button" class="btn btn-white px-10" style="margin-right: 40px;">Book Today</button></a>
            </div>
        </div>
    </ng-template>
</swiper>

<div class="swiper-buttons text-right">
    <button class="btn btn-white shadow-xs rounded-circle btn-previous" 
            [class.disabled]="isBegin" 
            (click)="gotoPrevious()"
    >
        <mat-icon aria-hidden="false" aria-label="Previous">arrow_back</mat-icon>
    </button>
    <button class="btn btn-white shadow-xs rounded-circle btn-next" 
            [class.disabled]="isEnd" 
            (click)="gotoNext()"
    >
        <mat-icon aria-hidden="false" aria-label="Next">arrow_forward</mat-icon>
    </button>
</div>